/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Endpoint_Pricing_HeadingInputs */

const en_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API pricing`)
};

const zh_hans1_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 价格`)
};

const pt_br2_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preços do endpoint ${i?.action} da API para ${i?.name}`)
};

const es_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Precios del endpoint ${i?.action} de la API de ${i?.name}`)
};

const fr_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarifs de l’API ${i?.name} ${i?.action}`)
};

const de_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preise der ${i?.name}-${i?.action}-API`)
};

const ru_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Цена API ${i?.name} ${i?.action}`)
};

const it_endpoint_pricing_heading = /** @type {(inputs: Endpoint_Pricing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prezzi dell'API ${i?.name} ${i?.action}`)
};

/**
* | output |
* | --- |
* | "{name} {action} API pricing" |
*
* @param {Endpoint_Pricing_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_pricing_heading = /** @type {((inputs: Endpoint_Pricing_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Pricing_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_pricing_heading(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_pricing_heading(inputs)
	if (locale === "es") return es_endpoint_pricing_heading(inputs)
	if (locale === "fr") return fr_endpoint_pricing_heading(inputs)
	if (locale === "de") return de_endpoint_pricing_heading(inputs)
	if (locale === "ru") return ru_endpoint_pricing_heading(inputs)
	if (locale === "it") return it_endpoint_pricing_heading(inputs)
	return en_endpoint_pricing_heading(inputs)
});